import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { useReactToPrint } from 'react-to-print';

import BulletinnoteProfileLayout from '../BulletinnoteProfileLayout';
import PrintBulletinAnnuel from './PrintBulletinAnnuel';
import useYear from './useYear'; // Assurez-vous que ce chemin est correct

const DetailsBulletinAnnuel = () => {
	const componentRef = useRef();
	const handlePrint = useReactToPrint({
		content: () => componentRef.current
	});

	const { yearOptions, selectedYear, handleYearChange } = useYear();

	return (
		<BulletinnoteProfileLayout>
			<Card className="w-100">
				<Row className="align-items-center pt-3 mb-6 px-3">
					<Col>
						<Form.Group as={Row} className="mb-3">
							<Col sm={6}>
								<Form.Label htmlFor="anneescolaire">Année Scolaire</Form.Label>
								<Form.Select
									id="anneescolaire"
									name="anneescolaire"
									size="sm"
									value={selectedYear.id || ''} // Assurez-vous d'utiliser l'ID pour le binding
									onChange={(e) =>
										handleYearChange(parseInt(e.target.value, 10))
									}
								>
									{yearOptions.map((option, index) => (
										<option key={index} value={option.value}>
											{option.label}
										</option>
									))}
								</Form.Select>
							</Col>
						</Form.Group>
					</Col>
					<Col className="text-end mb-3">
						<Link
							to="#"
							className="text-muted print-link no-print text-end"
							onClick={handlePrint}
						>
							<i className="fa-solid fa-print"></i>
						</Link>
					</Col>
				</Row>
				<PrintBulletinAnnuel ref={componentRef} selectedYear={selectedYear} />
			</Card>
		</BulletinnoteProfileLayout>
	);
};

export default DetailsBulletinAnnuel;
